import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

interface TitleWithChildrenProps {
  title?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  titleAction?: React.ReactNode;
}

const TitleWithChildren: React.FC<TitleWithChildrenProps> = ({
  title,
  icon,
  children,
  titleAction,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "flex-start",
        gap: theme.nawy.spacing.sm,
      }}
    >
      {icon && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {icon}
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          flex: 1,
        }}
      >
        {title && (
          <Typography
            sx={{
              ...theme.nawy.typography.english.variants.body.xs.regular,
              color: theme.nawy.colors.semantic.text.secondary,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {title}
            {titleAction}
          </Typography>
        )}

        {children}
      </Box>
    </Box>
  );
};

export default TitleWithChildren;
